import { GA_MEASUREMENT_ID } from './config/analytics';
import { lerConsentimento, EVENTO_CONSENTIMENTO } from './consentimento';

// Liga o Google Analytics 4 e registra os cliques que importam para a escola
// (WhatsApp, telefone, portais, PDFs, tour...). Não precisa mexer nas páginas:
// um único "ouvinte" de cliques identifica o tipo de link pelo endereço.
//
// Páginas vistas (inclusive as trocas de página dentro do site) são contadas
// automaticamente pela "medição otimizada" do próprio GA4.

const ID_VALIDO = /^G-[A-Z0-9]+$/;

// Cada regra: [nome do evento no Analytics, teste no endereço do link]
const REGRAS = [
  ['clique_whatsapp', (h) => h.includes('wa.me/') || h.includes('api.whatsapp.com') || h.includes('whatsapp://')],
  ['clique_telefone', (h) => h.startsWith('tel:')],
  ['clique_email', (h) => h.startsWith('mailto:')],
  ['acesso_portal_aluno', (h) => h.includes('cpa.escolarmanageronline.com.br')],
  ['acesso_portal_professor', (h) => h.includes('professor.escolarmanageronline.com.br')],
  ['clique_comprar_livros', (h) => h.includes('educarlivros.com')],
  ['clique_como_chegar', (h) => h.includes('google.com/maps') || h.includes('maps.google.')],
  ['clique_rede_social', (h) => h.includes('instagram.com') || h.includes('tiktok.com')],
  ['clique_baixar_app', (h) => h.includes('canva.site')],
  ['abrir_tour360', (h) => /(^|\/)tour360(\/|$|\?|#)/.test(h)],
  ['download_pdf', (h) => /\.pdf($|\?|#)/i.test(h)],
];

// Descreve de onde veio o clique (qual bloco da página) — ajuda a saber,
// por exemplo, qual dos botões de WhatsApp as famílias mais usam.
const BLOCOS = [
  ['.whatsapp-container', 'botao_flutuante'],
  ['footer', 'rodape'],
  ['#header', 'menu'],
  ['.fundoInicio', 'banner_inicial'],
  ['#matricule-se', 'faixa_matriculas'],
  ['.contato-rapido', 'contato_rapido'],
  ['.alunoOnline', 'botoes_portais'],
  ['.informacoesLivros', 'compra_livros'],
  ['.materiaisSection', 'lista_materiais'],
  ['.testimonials', 'depoimentos'],
  ['.parceiros-container', 'parceiros'],
];

function localDoClique(el) {
  const achado = BLOCOS.find(([seletor]) => el.closest(seletor));
  return achado ? achado[1] : 'conteudo';
}

function aoClicar(evento) {
  const link = evento.target.closest && evento.target.closest('a[href]');
  if (!link || typeof window.gtag !== 'function') return;

  const href = link.getAttribute('href') || '';
  const regra = REGRAS.find(([, teste]) => teste(href));
  if (!regra) return;

  const texto = (link.innerText || link.getAttribute('aria-label') || '').trim().slice(0, 80);
  window.gtag('event', regra[0], {
    pagina: window.location.pathname,
    local: localDoClique(link),
    texto_link: texto,
    destino: href.slice(0, 150),
  });
}

let carregado = false;

function carregarGoogleAnalytics() {
  if (carregado) {
    window[`ga-disable-${GA_MEASUREMENT_ID}`] = false; // voltou a aceitar
    return;
  }
  carregado = true;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', GA_MEASUREMENT_ID);

  document.addEventListener('click', aoClicar, true);
}

// Só liga o Analytics se a pessoa ACEITAR os cookies (LGPD) — ver
// componentes/js/AvisoCookies.js. Se ela recusar depois, o envio é desligado.
export function iniciarAnalytics() {
  if (!ID_VALIDO.test(GA_MEASUREMENT_ID)) return; // sem ID: não faz nada
  if (/^(localhost|127\.0\.0\.1)$/.test(window.location.hostname)) return; // não conta testes locais

  if (lerConsentimento() === 'aceito') carregarGoogleAnalytics();

  window.addEventListener(EVENTO_CONSENTIMENTO, (e) => {
    if (e.detail === 'aceito') {
      carregarGoogleAnalytics();
    } else if (carregado) {
      window[`ga-disable-${GA_MEASUREMENT_ID}`] = true;
    }
  });
}
